
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13531",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13531",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1149",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10125",
  "foundations-components": "static-1.8767",
  "foundations-components-legacy": "static-1.1792",
  "foundations-theming": "static-1.4976",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8525",
  "hub-http-shared-msw-handlers": "static-1.10923",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11973",
  "I18n": "static-7.1709",
  "jasmine-runner": "static-1.6939",
  "marketplace-discovery-studio-lib": "static-1.926",
  "marketplace-storefront-base": "static-1.13594",
  "quartz": "static-1.7682",
  "react-dlb": "static-1.94",
  "react-rhumb": "static-1.17225",
  "reactive-variable-buffer-atom": "static-1.3339",
  "reporting-testing-lib": "static-1.11323",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13014",
  "SharedI18nStrings": "static-1.188",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7869",
  "ui-addon-i18n": "static-1.11631",
  "ui-addon-react-router-dom": "static-1.10011",
  "unified-auth": "static-1.1280",
  "unified-auth-core-lib": "static-1.1562",
  "usage-tracker": "static-1.7809",
  "usage-tracker-core": "static-1.7659",
  "customer-data-property-utils": "static-1.8538",
  "hub-http": "static-1.6692",
  "integrations-lib": "static-1.17456",
  "marketplace-ui-common": "static-1.21050",
  "marketplace-ui-install": "static-1.1036",
  "property-management-iframe": "static-1.14478",
  "quartz-config": "static-1.1460",
  "quartz-core": "static-1.6901",
  "quartz-routing": "static-1.1112",
  "quick-fetch": "static-1.4238",
  "react": "static-7.203",
  "rpc-client-utils": "static-1.5155",
  "ts-schema": "static-1.4402",
  "ui-universal-auth": "static-1.9766",
  "UIComponents": "static-3.8919",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3959",
  "quartz-webpack": "static-1.3906",
  "bend-plugin-quartz-routing": "static-1.760",
  "ai-components-ui-library": "static-1.10044",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5374",
  "pulse": "static-1.1134",
  "react-codemirror": "static-1.11128",
  "ui-extensions-preview-lib": "static-1.1000",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5036",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2692",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9915",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5665",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3115",
  "ui-fonts": "static-1.1235",
  "ui-images": "static-2.1278",
  "bend-plugin-foundations-theming": "static-1.3459",
  "foundations-theming-base": "static-1.3961",
  "stylex": "static-1.46",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3636",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4792",
  "ui-addon-video-player": "static-1.9109",
  "ai-rendering-library": "static-1.11422",
  "chirp-fetch": "static-1.2391",
  "connections-embed-lib": "static-1.1776",
  "copilot-toolkit": "static-1.12174",
  "feedback-loader": "static-1.30078",
  "laboratory-lib": "static-3.7633",
  "marketplace-embed": "static-1.23223",
  "marketplace-ui-details": "static-1.10945",
  "marketplace-ui-reviews": "static-1.21005",
  "marketplace-ui-tracking": "static-1.15220",
  "sanitize-text": "static-1.8644",
  "usage-tracker-multi": "static-1.6223",
  "usage-tracker-session-replay": "static-1.5495",
  "beacon-keepalive-queue": "static-1.186",
  "quartz-head": "static-1.1347",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5075",
  "immer": "static-1.105",
  "immerable": "static-1.4628",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2846",
  "reporting-data": "static-1.69390",
  "cssUtils": "static-1.1109",
  "flux-actions": "static-1.381",
  "react-colorpicker": "static-2.10696",
  "react-dnd-compat": "static-1.5096",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10856",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7799",
  "icons": "static-2.704",
  "marketplace-ui-apps-core": "static-1.19582",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4984",
  "foundations-components-test-utils": "static-1.6250",
  "quartz-i18n": "static-1.1357",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.786",
  "ads-unified-auth-lib": "static-1.2030",
  "ai-mcp-auth-lib": "static-1.32",
  "custom-vendor-connection-lib": "static-1.330",
  "gemini-settings-lib": "static-1.9813",
  "google-sheets-integration-lib": "static-1.1355",
  "microsoft-drive-auth-lib": "static-1.568",
  "slack-ui-library": "static-1.10885",
  "surveymonkey-integration-lib": "static-1.892",
  "fsm": "static-1.4244",
  "customer-data-objects": "static-1.8193",
  "property-translator": "static-1.5866",
  "hs-locale-management": "static-1.409",
  "frontend-preferences-client": "static-1.8408",
  "hs-promise-utils": "static-1.6078",
  "hubspot-apollo-client": "static-1.5369",
  "integrations-error-boundary-lib": "static-1.14871",
  "integrations-tracking-lib": "static-1.6109",
  "native-integrations-shared-strings": "static-1.8249",
  "sanitize": "static-1.4961",
  "superstore": "static-1.5245",
  "ui-shepherd-react": "static-3.10766",
  "ai-settings-ui-library": "static-1.8613",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4982",
  "immutable-less": "static-1.5138",
  "marketplace-ui-client-types": "static-1.18457",
  "nav-meta": "static-1.30832",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18553",
  "ui-product-approvals-common": "static-1.1611",
  "ai-studio-lib": "static-1.12792",
  "hubspot-prosemirror": "static-1.19304",
  "integrations-reconnect-lib": "static-1.749",
  "ui-addon-iframeable": "static-1.9564",
  "ui-addon-integrations-directory-panel": "static-2.8440",
  "ui-product-approvals": "static-1.29716",
  "ui-tool-access": "static-1.10644",
  "inbound-db-properties-service-client": "static-1.4158",
  "property-management-common": "static-1.6766",
  "opentelemetry-fe-types": "static-1.277",
  "dispatcher": "static-1.148",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.652",
  "quartz-auth": "static-1.1357",
  "quartz-test": "static-1.1357",
  "quartz-tracking": "static-1.1061",
  "trellis-components": "static-1.3134",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.565",
  "HubStyle": "static-2.12280",
  "bender-build-tools": "static-1.3600",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23950",
  "ContentUtils": "static-1.69502",
  "customer-data-objects-ui-components": "static-1.13522",
  "sassPrefix": "static-1.374",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2035",
  "bend-plugin-pulse": "static-1.637",
  "event-emitter": "static-1.1448",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5916",
  "magpie-types": "static-1.5376",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1500",
  "avatar-components": "static-1.2973",
  "breeze-engine-core": "static-1.1507",
  "breeze-engine-lib": "static-1.2229",
  "breeze-onboarding-components": "static-1.1088",
  "customer-data-filters-ui": "static-1.41406",
  "customer-data-reference-ui-components": "static-1.13660",
  "data-integrations-breeze": "static-1.352",
  "embedded-academy-lib": "static-1.16041",
  "ExportDialog": "static-6.10859",
  "global-styles-ai-lib": "static-1.515",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.926",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.45",
  "reporting-action-components": "static-1.42429",
  "reporting-snowflake": "static-1.58006",
  "reporting-ui-components": "static-2.66659",
  "reporting-visualizations": "static-1.61464",
  "trial-components-library": "static-1.14401",
  "ui-addon-teams": "static-1.22024",
  "upgrade-components-lib": "static-1.741",
  "navigation-components": "static-1.19195",
  "nest": "static-1.722",
  "simple-logging-lib": "static-1.3537",
  "nudge-client-utils": "static-1.3442",
  "fail-safe": "static-1.436",
  "app-governance-lib": "static-1.2764",
  "developer-experience-shared-components": "static-1.11027",
  "purchase-motions-components": "static-1.6647",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10815",
  "usage-tracker-anonymous": "static-1.6226",
  "usage-tracker-public": "static-1.7620",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3782",
  "persist-promise": "static-1.4192",
  "reference-resolvers": "static-1.8670",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4401",
  "hubspot-apollo-cache": "static-1.828",
  "universal-page-editor-lib": "static-1.3499",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3845",
  "merchandise-lib": "static-1.286",
  "onboarding-scopes": "static-1.6940",
  "ui-addon-draggable": "static-3.5235",
  "content-assistance-lib": "static-1.8440",
  "content-media-capture": "static-1.5817",
  "customer-data-ui-utilities": "static-1.10318",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24861",
  "growth-payments-core": "static-1.26525",
  "knowledge-content-types": "static-1.8766",
  "PatternValidationJS": "static-1.3370",
  "payment-link-components": "static-1.24480",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20573",
  "ui-addon-emoji-picker": "static-1.10349",
  "ui-business-units-lib": "static-1.9583",
  "video-components-external": "static-1.12463",
  "video-data-lib": "static-1.36121",
  "navigation-messaging": "static-1.8522",
  "collaboration-sidebar": "static-1.59083",
  "trellis-ext-dnd": "static-1.561",
  "crm-component-utils": "static-1.40218",
  "crm-properties-common-lib": "static-1.6383",
  "customer-data-properties": "static-1.53085",
  "external-options-client-types": "static-1.4446",
  "hs-resources": "static-1.671",
  "property-value-citations": "static-1.3699",
  "reference-resolvers-lite": "static-1.8599",
  "opentelemetry-web": "static-1.23",
  "hubspotter-http-shared-msw-handlers": "static-1.10921",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5296",
  "content-icons-ui": "static-1.2468",
  "atom": "static-1.5558",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1207",
  "trellis-migration-context": "static-1.67",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1207",
  "breeze-artifacts-sdk": "static-1.1018",
  "getting-started-shared-tasks": "static-1.19586",
  "onboarding-journeys-lib": "static-1.1253",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44135",
  "customer-data-filters-ui-msw-helpers": "static-1.23841",
  "events-data-lib": "static-1.733",
  "FormUrlGenerator": "static-2.5200",
  "framework-builder-read-service-client": "static-1.4342",
  "multi-account-reference-resolvers": "static-1.1498",
  "onboarding-tours": "static-1.17411",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14790",
  "segments-client-types": "static-1.12203",
  "academy-common-lib": "static-1.15502",
  "dashboard-lib": "static-1.83331",
  "hubspot-prosemirror-plugins": "static-1.19296",
  "share-with-third-party-component-lib": "static-1.9198",
  "ui-asset-management-lib": "static-1.11587",
  "user-context": "static-1.5540",
  "reporting-plugins": "static-1.11010",
  "reporting-reports": "static-1.69066",
  "hubs-service-types": "static-1.1754",
  "purchase-motions-api": "static-1.6650",
  "salesImages": "static-1.744",
  "signup-constants": "static-1.19966",
  "nudge-custom-function-registry": "static-1.3199",
  "nudge-renderer-utils": "static-1.3518",
  "whisper-core-api": "static-1.7660",
  "bend-plugin-fail-safe": "static-1.387",
  "framework-listing-lib": "static-2.29834",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31776",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4623",
  "signup-ui-url-generator": "static-2.8524",
  "onboarding-tours-client": "static-1.5626",
  "one-click-checkout": "static-1.760",
  "platform-infra-nav-components": "static-1.8009",
  "subscription-experience-data-types": "static-1.15452",
  "crm-record-cards-client": "static-1.83",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7379",
  "location-customization-utils-lib": "static-1.10444",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29595",
  "content-media-composition-data-lib": "static-1.13621",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4915",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3964",
  "seat-types-lib": "static-1.1070",
  "ui-addon-opt": "static-4.8899",
  "commerce-tours-lib": "static-1.6879",
  "growth-onboarding-reliability": "static-1.5570",
  "sales-checkout-service-client": "static-1.4007",
  "data-token-picker": "static-1.17153",
  "FileManagerLib": "static-1.40501",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19659",
  "chatspot-widget-iframe": "static-1.23941",
  "collaboration-sidebar-common": "static-1.3880",
  "marketing-platform-lib": "static-1.7392",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38078",
  "crm-actions": "static-1.6863",
  "crm-cards-sdk": "static-1.45054",
  "customer-data-properties-shared-msw-handlers": "static-1.10250",
  "customer-data-tracking": "static-1.7358",
  "calling-global-api": "static-1.66227",
  "calling-internal-common": "static-1.31811",
  "calling-lifecycle-internal": "static-1.67609",
  "calling-lifecycle-messages": "static-1.59901",
  "commerce-products-lib": "static-1.10940",
  "conditional-properties-service-client": "static-1.4120",
  "crm-index-visualization-core": "static-1.4774",
  "crm-links": "static-1.6799",
  "crm-pipelines-api-client-types": "static-1.4451",
  "data-agent-utils": "static-1.952",
  "formula-editor": "static-1.15026",
  "google-libphonenumber": "static-1.50",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1118",
  "multi-currency-client-types": "static-1.4015",
  "object-builder-ui-client": "static-1.50076",
  "pipeline-validation-client-types": "static-1.4290",
  "smart-data-capture-core": "static-1.506",
  "smart-property-lib": "static-1.8683",
  "tiered-pricing": "static-1.2302",
  "topics-actions-lib": "static-1.670",
  "trellis-ext-i18n": "static-1.1405",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.498",
  "restore-request-side-panel-lib": "static-1.2049",
  "growth-data-modal": "static-1.6153",
  "growth-onboarding-confetti": "static-1.3544",
  "growth-onboarding-next-action-utils": "static-1.3007",
  "onboarding-tours-utils": "static-1.1478",
  "ui-shepherd-tracker": "static-1.8147",
  "crm-index-associations-lib": "static-1.6934",
  "academy-service-client": "static-1.4178",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40360",
  "SafeStorage": "static-1.4883",
  "video-embed": "static-1.36955",
  "wootric-nps": "static-1.7305",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25269",
  "viral-links-lib": "static-1.7569",
  "nested-table": "static-1.718",
  "timezone-utils": "static-2.5717",
  "getting-started-shared-tasks-store": "static-1.18704",
  "campaign-roi-lib": "static-1.10855",
  "campaigns-utils-lib": "static-1.3736",
  "ui-addon-calendars": "static-2.5851",
  "customer-data-views-management": "static-1.26378",
  "framework-data-table": "static-2.12859",
  "nudge-custom-ui-functions": "static-1.1758",
  "switchboard-lib": "static-1.723",
  "access-check-ui-lib": "static-1.1905",
  "app-users-service-client": "static-1.6107",
  "app-users-service-types": "static-1.5515",
  "mini-checkout-client": "static-1.27855",
  "onboarding-utils": "static-1.5860",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29580",
  "checkout-sdk": "static-3.24698",
  "payment-method-components": "static-1.7330",
  "touchless-buying-components": "static-1.6566",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.878",
  "framework-data-schema-quick-fetch": "static-1.7284",
  "growth-onboarding-feedback-components": "static-1.7067",
  "audio-components": "static-1.6590",
  "FileManagerImages": "static-1.38012",
  "video-components": "static-1.14465",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20517",
  "commerce-shared-components-lib": "static-1.19595",
  "commerce-tools-ui-lib": "static-1.11343",
  "crm_data": "static-4.93230",
  "crm-activity-creator-data": "static-1.47766",
  "crm-fe-perf": "static-1.23385",
  "universal-record-utils-lib": "static-1.2391",
  "calling-error-reporting": "static-1.31818",
  "shared-worker-versioning": "static-1.11530",
  "calling-usage-tracker": "static-1.7027",
  "voice-sms-access-library": "static-1.2488",
  "commerce-permissions": "static-1.1272",
  "products-iframe-lib": "static-1.8938",
  "products-ui-components-shared-msw-handlers": "static-1.11305",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11006",
  "sales-views-client-types": "static-1.4745",
  "data-agent-kit": "static-1.939",
  "enrichment-settings-lib": "static-1.256",
  "policy-lib": "static-1.7290",
  "bark-lib": "static-1.17020",
  "browser-prettier": "static-1.11",
  "data-agent-test-utils": "static-1.483",
  "react-tinymce": "static-1.56288",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11069",
  "tinymce-config": "static-2.55414",
  "tinymce-plugins": "static-1.58528",
  "onboarding-data-sync-lib": "static-1.2857",
  "growth-onboarding-next-action-components": "static-1.3035",
  "user-context-client": "static-1.4996",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.5000",
  "outpost": "static-1.4615",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22377",
  "sales-email-signature-service-client": "static-1.4335",
  "ts-utils-lib": "static-1.638",
  "copilot-messaging": "static-1.2424",
  "crm-export-dialog": "static-1.6764",
  "crm-index-ui-shimmer": "static-1.3000",
  "crm-view-components": "static-1.1520",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7824",
  "tasks-actions-lib": "static-1.457",
  "InboxConnectUtils": "static-4.15864",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.881",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4473",
  "company-details-components": "static-1.6692",
  "react-performance-metrics-lib": "static-1.1039",
  "pricing-pages-ui-components": "static-1.16620",
  "quote-checkout-service-types": "static-1.3946",
  "social-insights-client-types": "static-1.22952",
  "utility-belt": "static-1.3024",
  "payments-enrollment-embed-lib": "static-1.24239",
  "stripe-embedded-components": "static-1.8265",
  "customer-data-rte": "static-1.33922",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6552",
  "payments-post-enroll-local-storage-lib": "static-1.5592",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39193",
  "crm_universal": "static-1.22744",
  "customer-data-email": "static-1.18660",
  "meetings-rte-lib": "static-1.563",
  "universal-associations-select": "static-1.11583",
  "crm-object-search-query-utilities": "static-1.10480",
  "calling-orchestration-schema": "static-1.37265",
  "react-reducer-toolkit": "static-1.16689",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57384",
  "hub-http-contrib": "static-1.3519",
  "interframe": "static-3.5228",
  "tinymce-data": "static-1.41499",
  "ui-addon-sales-email": "static-1.5688",
  "layout-dnd-components": "static-1.13245",
  "layout-dnd-utils": "static-1.12220",
  "ui-brand-identity-lib": "static-1.16980",
  "meetings-connect-utils-lib": "static-1.8106",
  "company-details-service-types": "static-1.4431",
  "segments-query-core": "static-1.1917",
  "pricing-pages-api": "static-1.16485",
  "stripe-connect-js": "static-1.83",
  "draft-content-plugins": "static-1.29176",
  "sequences-lib": "static-1.8806",
  "ui-gdpr-components": "static-1.10656",
  "meetings-client-types": "static-1.4077",
  "meetings-core": "static-1.785",
  "NamespacedHubStyle": "static-2.9375",
  "ContentData": "static-1.69577",
  "layout-data-lib": "static-1.10545",
  "sequences-client-types-lib": "static-1.8663",
  "advanced-menus-core": "static-1.15835",
  "advanced-menus-lib": "static-1.12582",
  "ui-memberships-settings-lib": "static-1.35225",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15834",
  "simple-menus-lib": "static-1.17351"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13531",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1149",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10125",
  "foundations-components": "/foundations-components/static-1.8767",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1792",
  "foundations-theming": "/foundations-theming/static-1.4976",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8525",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10923",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11973",
  "I18n": "/I18n/static-7.1709",
  "jasmine-runner": "/jasmine-runner/static-1.6939",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.926",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13594",
  "quartz": "/quartz/static-1.7682",
  "react-dlb": "/react-dlb/static-1.94",
  "react-rhumb": "/react-rhumb/static-1.17225",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3339",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11323",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13014",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7869",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11631",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10011",
  "unified-auth": "/unified-auth/static-1.1280",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1562",
  "usage-tracker": "/usage-tracker/static-1.7809",
  "usage-tracker-core": "/usage-tracker-core/static-1.7659",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8538",
  "hub-http": "/hub-http/static-1.6692",
  "integrations-lib": "/integrations-lib/static-1.17456",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1036",
  "property-management-iframe": "/property-management-iframe/static-1.14478",
  "quartz-config": "/quartz-config/static-1.1460",
  "quartz-core": "/quartz-core/static-1.6901",
  "quartz-routing": "/quartz-routing/static-1.1112",
  "quick-fetch": "/quick-fetch/static-1.4238",
  "react": "/react/static-7.203",
  "rpc-client-utils": "/rpc-client-utils/static-1.5155",
  "ts-schema": "/ts-schema/static-1.4402",
  "ui-universal-auth": "/ui-universal-auth/static-1.9766",
  "UIComponents": "/UIComponents/static-3.8919",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3959",
  "quartz-webpack": "/quartz-webpack/static-1.3906",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.760",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10044",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5374",
  "pulse": "/pulse/static-1.1134",
  "react-codemirror": "/react-codemirror/static-1.11128",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1000",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5036",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2692",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9915",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5665",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3115",
  "ui-fonts": "/ui-fonts/static-1.1235",
  "ui-images": "/ui-images/static-2.1278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3459",
  "foundations-theming-base": "/foundations-theming-base/static-1.3961",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3636",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4792",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9109",
  "ai-rendering-library": "/ai-rendering-library/static-1.11422",
  "chirp-fetch": "/chirp-fetch/static-1.2391",
  "connections-embed-lib": "/connections-embed-lib/static-1.1776",
  "copilot-toolkit": "/copilot-toolkit/static-1.12174",
  "feedback-loader": "/feedback-loader/static-1.30078",
  "laboratory-lib": "/laboratory-lib/static-3.7633",
  "marketplace-embed": "/marketplace-embed/static-1.23223",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10945",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21005",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15220",
  "sanitize-text": "/sanitize-text/static-1.8644",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6223",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5495",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.186",
  "quartz-head": "/quartz-head/static-1.1347",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5075",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4628",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2846",
  "reporting-data": "/reporting-data/static-1.69390",
  "cssUtils": "/cssUtils/static-1.1109",
  "flux-actions": "/flux-actions/static-1.381",
  "react-colorpicker": "/react-colorpicker/static-2.10696",
  "react-dnd-compat": "/react-dnd-compat/static-1.5096",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10856",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7799",
  "icons": "/icons/static-2.704",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4984",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6250",
  "quartz-i18n": "/quartz-i18n/static-1.1357",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.786",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2030",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.32",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.330",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9813",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1355",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.568",
  "slack-ui-library": "/slack-ui-library/static-1.10885",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.892",
  "fsm": "/fsm/static-1.4244",
  "customer-data-objects": "/customer-data-objects/static-1.8193",
  "property-translator": "/property-translator/static-1.5866",
  "hs-locale-management": "/hs-locale-management/static-1.409",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8408",
  "hs-promise-utils": "/hs-promise-utils/static-1.6078",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5369",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14871",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6109",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8249",
  "sanitize": "/sanitize/static-1.4961",
  "superstore": "/superstore/static-1.5245",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10766",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8613",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4982",
  "immutable-less": "/immutable-less/static-1.5138",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "nav-meta": "/nav-meta/static-1.30832",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18553",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1611",
  "ai-studio-lib": "/ai-studio-lib/static-1.12792",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19304",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.749",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9564",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8440",
  "ui-product-approvals": "/ui-product-approvals/static-1.29716",
  "ui-tool-access": "/ui-tool-access/static-1.10644",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4158",
  "property-management-common": "/property-management-common/static-1.6766",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.277",
  "dispatcher": "/dispatcher/static-1.148",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.652",
  "quartz-auth": "/quartz-auth/static-1.1357",
  "quartz-test": "/quartz-test/static-1.1357",
  "quartz-tracking": "/quartz-tracking/static-1.1061",
  "trellis-components": "/trellis-components/static-1.3134",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.565",
  "HubStyle": "/HubStyle/static-2.12280",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23950",
  "ContentUtils": "/ContentUtils/static-1.69502",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13522",
  "sassPrefix": "/sassPrefix/static-1.374",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2035",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.637",
  "event-emitter": "/event-emitter/static-1.1448",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5916",
  "magpie-types": "/magpie-types/static-1.5376",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1500",
  "avatar-components": "/avatar-components/static-1.2973",
  "breeze-engine-core": "/breeze-engine-core/static-1.1507",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2229",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1088",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41406",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13660",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.352",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16041",
  "ExportDialog": "/ExportDialog/static-6.10859",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.515",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.926",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.45",
  "reporting-action-components": "/reporting-action-components/static-1.42429",
  "reporting-snowflake": "/reporting-snowflake/static-1.58006",
  "reporting-ui-components": "/reporting-ui-components/static-2.66659",
  "reporting-visualizations": "/reporting-visualizations/static-1.61464",
  "trial-components-library": "/trial-components-library/static-1.14401",
  "ui-addon-teams": "/ui-addon-teams/static-1.22024",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.741",
  "navigation-components": "/navigation-components/static-1.19195",
  "nest": "/nest/static-1.722",
  "simple-logging-lib": "/simple-logging-lib/static-1.3537",
  "nudge-client-utils": "/nudge-client-utils/static-1.3442",
  "fail-safe": "/fail-safe/static-1.436",
  "app-governance-lib": "/app-governance-lib/static-1.2764",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11027",
  "purchase-motions-components": "/purchase-motions-components/static-1.6647",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10815",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6226",
  "usage-tracker-public": "/usage-tracker-public/static-1.7620",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3782",
  "persist-promise": "/persist-promise/static-1.4192",
  "reference-resolvers": "/reference-resolvers/static-1.8670",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4401",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.828",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3499",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3845",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "onboarding-scopes": "/onboarding-scopes/static-1.6940",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5235",
  "content-assistance-lib": "/content-assistance-lib/static-1.8440",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10318",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "growth-payments-core": "/growth-payments-core/static-1.26525",
  "knowledge-content-types": "/knowledge-content-types/static-1.8766",
  "PatternValidationJS": "/PatternValidationJS/static-1.3370",
  "payment-link-components": "/payment-link-components/static-1.24480",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20573",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10349",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9583",
  "video-components-external": "/video-components-external/static-1.12463",
  "video-data-lib": "/video-data-lib/static-1.36121",
  "navigation-messaging": "/navigation-messaging/static-1.8522",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59083",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.561",
  "crm-component-utils": "/crm-component-utils/static-1.40218",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6383",
  "customer-data-properties": "/customer-data-properties/static-1.53085",
  "external-options-client-types": "/external-options-client-types/static-1.4446",
  "hs-resources": "/hs-resources/static-1.671",
  "property-value-citations": "/property-value-citations/static-1.3699",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8599",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10921",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5296",
  "content-icons-ui": "/content-icons-ui/static-1.2468",
  "atom": "/atom/static-1.5558",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1207",
  "trellis-migration-context": "/trellis-migration-context/static-1.67",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1207",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1018",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19586",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1253",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44135",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23841",
  "events-data-lib": "/events-data-lib/static-1.733",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5200",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4342",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1498",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14790",
  "segments-client-types": "/segments-client-types/static-1.12203",
  "academy-common-lib": "/academy-common-lib/static-1.15502",
  "dashboard-lib": "/dashboard-lib/static-1.83331",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19296",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9198",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11587",
  "user-context": "/user-context/static-1.5540",
  "reporting-plugins": "/reporting-plugins/static-1.11010",
  "reporting-reports": "/reporting-reports/static-1.69066",
  "hubs-service-types": "/hubs-service-types/static-1.1754",
  "purchase-motions-api": "/purchase-motions-api/static-1.6650",
  "salesImages": "/salesImages/static-1.744",
  "signup-constants": "/signup-constants/static-1.19966",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3199",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3518",
  "whisper-core-api": "/whisper-core-api/static-1.7660",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.387",
  "framework-listing-lib": "/framework-listing-lib/static-2.29834",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31776",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4623",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8524",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "one-click-checkout": "/one-click-checkout/static-1.760",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8009",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15452",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.83",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7379",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10444",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29595",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4915",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3964",
  "seat-types-lib": "/seat-types-lib/static-1.1070",
  "ui-addon-opt": "/ui-addon-opt/static-4.8899",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6879",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5570",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4007",
  "data-token-picker": "/data-token-picker/static-1.17153",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19659",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23941",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3880",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7392",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38078",
  "crm-actions": "/crm-actions/static-1.6863",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45054",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10250",
  "customer-data-tracking": "/customer-data-tracking/static-1.7358",
  "calling-global-api": "/calling-global-api/static-1.66227",
  "calling-internal-common": "/calling-internal-common/static-1.31811",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67609",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59901",
  "commerce-products-lib": "/commerce-products-lib/static-1.10940",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4120",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4774",
  "crm-links": "/crm-links/static-1.6799",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4451",
  "data-agent-utils": "/data-agent-utils/static-1.952",
  "formula-editor": "/formula-editor/static-1.15026",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1118",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4015",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50076",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4290",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.506",
  "smart-property-lib": "/smart-property-lib/static-1.8683",
  "tiered-pricing": "/tiered-pricing/static-1.2302",
  "topics-actions-lib": "/topics-actions-lib/static-1.670",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1405",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.498",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2049",
  "growth-data-modal": "/growth-data-modal/static-1.6153",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3544",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3007",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8147",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6934",
  "academy-service-client": "/academy-service-client/static-1.4178",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "SafeStorage": "/SafeStorage/static-1.4883",
  "video-embed": "/video-embed/static-1.36955",
  "wootric-nps": "/wootric-nps/static-1.7305",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25269",
  "viral-links-lib": "/viral-links-lib/static-1.7569",
  "nested-table": "/nested-table/static-1.718",
  "timezone-utils": "/timezone-utils/static-2.5717",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18704",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10855",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3736",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5851",
  "customer-data-views-management": "/customer-data-views-management/static-1.26378",
  "framework-data-table": "/framework-data-table/static-2.12859",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1758",
  "switchboard-lib": "/switchboard-lib/static-1.723",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1905",
  "app-users-service-client": "/app-users-service-client/static-1.6107",
  "app-users-service-types": "/app-users-service-types/static-1.5515",
  "mini-checkout-client": "/mini-checkout-client/static-1.27855",
  "onboarding-utils": "/onboarding-utils/static-1.5860",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29580",
  "checkout-sdk": "/checkout-sdk/static-3.24698",
  "payment-method-components": "/payment-method-components/static-1.7330",
  "touchless-buying-components": "/touchless-buying-components/static-1.6566",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.878",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7284",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7067",
  "audio-components": "/audio-components/static-1.6590",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "video-components": "/video-components/static-1.14465",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20517",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19595",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11343",
  "crm_data": "/crm_data/static-4.93230",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47766",
  "crm-fe-perf": "/crm-fe-perf/static-1.23385",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2391",
  "calling-error-reporting": "/calling-error-reporting/static-1.31818",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11530",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7027",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2488",
  "commerce-permissions": "/commerce-permissions/static-1.1272",
  "products-iframe-lib": "/products-iframe-lib/static-1.8938",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11305",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11006",
  "sales-views-client-types": "/sales-views-client-types/static-1.4745",
  "data-agent-kit": "/data-agent-kit/static-1.939",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.256",
  "policy-lib": "/policy-lib/static-1.7290",
  "bark-lib": "/bark-lib/static-1.17020",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.483",
  "react-tinymce": "/react-tinymce/static-1.56288",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11069",
  "tinymce-config": "/tinymce-config/static-2.55414",
  "tinymce-plugins": "/tinymce-plugins/static-1.58528",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2857",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3035",
  "user-context-client": "/user-context-client/static-1.4996",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.5000",
  "outpost": "/outpost/static-1.4615",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22377",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4335",
  "ts-utils-lib": "/ts-utils-lib/static-1.638",
  "copilot-messaging": "/copilot-messaging/static-1.2424",
  "crm-export-dialog": "/crm-export-dialog/static-1.6764",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3000",
  "crm-view-components": "/crm-view-components/static-1.1520",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7824",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.457",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15864",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.881",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4473",
  "company-details-components": "/company-details-components/static-1.6692",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1039",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16620",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3946",
  "social-insights-client-types": "/social-insights-client-types/static-1.22952",
  "utility-belt": "/utility-belt/static-1.3024",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24239",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8265",
  "customer-data-rte": "/customer-data-rte/static-1.33922",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6552",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5592",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39193",
  "crm_universal": "/crm_universal/static-1.22744",
  "customer-data-email": "/customer-data-email/static-1.18660",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.563",
  "universal-associations-select": "/universal-associations-select/static-1.11583",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10480",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37265",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16689",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57384",
  "hub-http-contrib": "/hub-http-contrib/static-1.3519",
  "interframe": "/interframe/static-3.5228",
  "tinymce-data": "/tinymce-data/static-1.41499",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5688",
  "layout-dnd-components": "/layout-dnd-components/static-1.13245",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12220",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16980",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8106",
  "company-details-service-types": "/company-details-service-types/static-1.4431",
  "segments-query-core": "/segments-query-core/static-1.1917",
  "pricing-pages-api": "/pricing-pages-api/static-1.16485",
  "stripe-connect-js": "/stripe-connect-js/static-1.83",
  "draft-content-plugins": "/draft-content-plugins/static-1.29176",
  "sequences-lib": "/sequences-lib/static-1.8806",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "meetings-client-types": "/meetings-client-types/static-1.4077",
  "meetings-core": "/meetings-core/static-1.785",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9375",
  "ContentData": "/ContentData/static-1.69577",
  "layout-data-lib": "/layout-data-lib/static-1.10545",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8663",
  "advanced-menus-core": "/advanced-menus-core/static-1.15835",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12582",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35225",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15834",
  "simple-menus-lib": "/simple-menus-lib/static-1.17351"
}
};
